import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../language/language.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  constructor(public languageService: LanguageService) { }

  ngOnInit(): void {
  }

}
